/* =========================================================
   Lumière Jewelry Theme — Core UI behavior
   Header, mobile menu, accordions, variant picker, quick add modal
   ========================================================= */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------- Sticky header on scroll ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var current = window.pageYOffset;
      header.classList.toggle('is-scrolled', current > 10);
      if (current > lastScroll && current > 160) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastScroll = current;
    }, { passive: true });
  }

  /* ---------- Mobile menu drawer ---------- */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileClose = document.querySelector('[data-mobile-menu-close]');

  function openDrawer(el) {
    if (!el) return;
    el.removeAttribute('hidden');
    requestAnimationFrame(function () { el.setAttribute('open', ''); });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(el) {
    if (!el) return;
    el.removeAttribute('open');
    document.body.style.overflow = '';
    setTimeout(function () { el.setAttribute('hidden', ''); }, 350);
  }

  if (mobileToggle) mobileToggle.addEventListener('click', function () { openDrawer(mobileMenu); });
  if (mobileClose) mobileClose.addEventListener('click', function () { closeDrawer(mobileMenu); });

  /* ---------- Desktop nav dropdowns ---------- */
  /* Opens on hover / focus-within via CSS alone (see base.css). The click
     handling here is the keyboard/touch fallback: it toggles the same
     `open` attribute the rest of the theme uses for expandable state
     (see the product accordion below), so a single CSS rule covers both
     the hover case and the click-toggled case. */
  document.querySelectorAll('[data-nav-dropdown]').forEach(function (item) {
    var toggle = item.querySelector('[data-nav-dropdown-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = item.hasAttribute('open');

      document.querySelectorAll('[data-nav-dropdown][open]').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.removeAttribute('open');
          var t = openItem.querySelector('[data-nav-dropdown-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });

      if (isOpen) {
        item.removeAttribute('open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        item.setAttribute('open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('[data-nav-dropdown][open]').forEach(function (openItem) {
      openItem.removeAttribute('open');
      var t = openItem.querySelector('[data-nav-dropdown-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-nav-dropdown][open]').forEach(function (openItem) {
      openItem.removeAttribute('open');
      var t = openItem.querySelector('[data-nav-dropdown-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---------- Mobile menu submenus (nested accordion) ---------- */
  /* Each toggle only opens the <li> it belongs to (via closest), so this
     naturally supports the nested grandchild level too without extra code. */
  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-mobile-submenu-item]');
      if (!item) return;
      var isOpen = item.hasAttribute('open');
      if (isOpen) {
        item.removeAttribute('open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.setAttribute('open', '');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- Cart drawer toggle (header icon) ---------- */
  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(document.querySelector('[data-cart-drawer]'));
    });
  });
  if (mobileMenu) {
    var overlay = mobileMenu.querySelector('.mobile-menu__overlay');
    if (overlay) overlay.addEventListener('click', function () { closeDrawer(mobileMenu); });
  }

  /* ---------- Search drawer ---------- */
  var searchDrawer = document.querySelector('[data-search-drawer]');
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(searchDrawer);
      var input = searchDrawer && searchDrawer.querySelector('input[name="q"]');
      if (input) setTimeout(function () { input.focus(); }, 100);
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { closeDrawer(searchDrawer); });
  });

  /* ---------- Generic drawer trigger (cart, quick add) ---------- */
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeDrawer(btn.closest('[data-drawer]'));
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-drawer][open]').forEach(function (el) { closeDrawer(el); });
    var quickAdd = document.getElementById('quick-add-modal');
    if (quickAdd && !quickAdd.hasAttribute('hidden')) quickAdd.setAttribute('hidden', '');
  });

  window.LumiereTheme = window.LumiereTheme || {};
  window.LumiereTheme.openDrawer = openDrawer;
  window.LumiereTheme.closeDrawer = closeDrawer;

  /* ---------- Product accordions ---------- */
  document.querySelectorAll('.product__accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.product__accordion-item');
      var isOpen = item.hasAttribute('open');
      item.querySelectorAll(':scope > .product__accordion-content').forEach(function () {});
      if (isOpen) {
        item.removeAttribute('open');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        item.setAttribute('open', '');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- Product image thumbnails ---------- */
  document.querySelectorAll('[data-product-thumbnail]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var wrapper = thumb.closest('[data-product-gallery]');
      var mainImg = wrapper.querySelector('[data-product-main-image]');
      wrapper.querySelectorAll('[data-product-thumbnail]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) mainImg.src = thumb.dataset.fullSrc || thumb.querySelector('img').src;
    });
  });

  /* ---------- Product image zoom on click ---------- */
  document.querySelectorAll('[data-product-main-image-wrap]').forEach(function (wrap) {
    wrap.addEventListener('click', function () {
      wrap.classList.toggle('is-zoomed');
    });
  });

  /* ---------- Quantity selectors ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty-wrapper]');
    var input = wrap.querySelector('input[type="number"]');
    var value = parseInt(input.value, 10) || 1;
    if (minus) value = Math.max(parseInt(input.min || 1, 10), value - 1);
    if (plus) value = value + 1;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant picker (product page, non-modal) ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    var variantsJson = picker.dataset.variants;
    var variants = [];
    try { variants = JSON.parse(variantsJson); } catch (err) { variants = []; }

    function getSelectedOptions() {
      var selected = [];
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        selected[parseInt(input.dataset.optionIndex, 10)] = input.value;
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function updateUI() {
      var selected = getSelectedOptions();
      var match = findVariant(selected);
      var idInput = form.querySelector('input[name="id"]');
      var addBtn = form.querySelector('[data-add-to-cart]');
      var priceEl = document.querySelector('[data-product-price]');

      if (match) {
        if (idInput) idInput.value = match.id;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.querySelector('[data-btn-text]').textContent = match.available
            ? addBtn.dataset.labelAvailable
            : addBtn.dataset.labelSoldOut;
        }
        if (priceEl && match.price !== undefined) {
          priceEl.querySelector('[data-price-amount]').textContent = window.LumiereTheme.formatMoney(match.price);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    }

    picker.addEventListener('change', updateUI);
    updateUI();
  });

  /* ---------- Money formatting (basic) ---------- */
  window.LumiereTheme.formatMoney = function (cents) {
    var value = (cents / 100).toFixed(2);
    return (window.themeMoneyFormat || '{{amount}}').replace('{{amount}}', value);
  };

  /* ---------- Newsletter form UX ---------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'disabled');
    });
  });
})();